import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSubjectIcon } from '../common/subjectIconMap';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StudyRoomHistoryItem = ({ session, onClick }) => {
    const { t } = useTranslation();

    const formatDate = (dateStr) => {
        const d = new Date(dateStr);
        const month = d.getMonth() + 1;
        const day = d.getDate();
        const hours = String(d.getHours()).padStart(2, '0');
        const mins = String(d.getMinutes()).padStart(2, '0');
        return `${month}/${day} ${hours}:${mins}`;
    };

    const formatTime = (dateStr) => {
        const d = new Date(dateStr);
        return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    const formatDuration = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        if (h > 0) return `${h}${t('studyroom.hour')} ${m}${t('studyroom.min')}`;
        return `${m}${t('studyroom.min')}`;
    };

    const thumbnailUrl = session.has_timelapse && session.thumbnail_path
        ? `${API_URL}/uploads/${session.thumbnail_path}`
        : null;

    const studySessions = session.studySessions || [];
    const maxSeconds = studySessions.length > 0
        ? Math.max(...studySessions.map(ss => ss.total_seconds), 1)
        : 1;

    return (
        <div className="history-section-item history-section-clickable" onClick={() => onClick(session)}>
            <div className="history-section-header">
                <div className="history-section-title">
                    <span className="history-section-date">{formatDate(session.opened_at)}</span>
                    <span className="history-section-range"> ~ {formatTime(session.closed_at)}</span>
                </div>
                <div className="history-section-meta">
                    <span className="history-section-duration">{formatDuration(session.duration_seconds)}</span>
                    {session.has_timelapse && (
                        <span className="history-timelapse-badge">&#9654;</span>
                    )}
                </div>
            </div>

            <div className="history-section-body">
                {thumbnailUrl && (
                    <div className="history-thumbnail">
                        <img src={thumbnailUrl} alt="timelapse" />
                    </div>
                )}

                <div className="history-section-content">
                    {studySessions.length > 0 ? (
                        <div className="history-section-subjects">
                            {studySessions.map((ss, idx) => (
                                <div key={idx} className="history-subject-row">
                                    <div className="history-subject-name">
                                        <span className="history-subject-icon">{getSubjectIcon(ss.subject_name)}</span>
                                        {ss.subject_name}
                                    </div>
                                    <div className="history-subject-hours">
                                        <div
                                            className="history-hours-bar"
                                            style={{
                                                width: `${(ss.total_seconds / maxSeconds) * 100}%`,
                                                backgroundColor: ss.subject_color || '#4CAF50'
                                            }}
                                        />
                                        <span>{formatDuration(ss.total_seconds)}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="history-section-empty">
                            {t('studyroom.history.noStudy')}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StudyRoomHistoryItem;
